module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"alert-title-1":"Você tem","alert-title-2":"dias restantes","alert-title-3":"para abrir uma disputa desta contestação.","create-dispute":"Disputar contestação"},"en-US":{"alert-title-1":"You have","alert-title-2":"days remaining","alert-title-3":"to open a chargeback dispute.","create-dispute":"Disputar contestação"}}')
  delete Component.options._Ctor
}
